import { useCallback } from 'react';
import {useDelete, UseDeleteParams} from "../../../../api";

const ENDPOINT = '/insights/customExposure';

export type UseDeleteCustomExposureParams = UseDeleteParams<string, {}>;

const useDeleteCustomExposure = (useDeleteParams: UseDeleteCustomExposureParams) => {
    const { deleteMethod, ...rest } = useDelete<string, string>(useDeleteParams);

    const deleteCustomExposures = useCallback(
        (id: string) => deleteMethod(`${ENDPOINT}/${id}`),
        [deleteMethod]
    );

    return {
        ...rest,
        deleteCustomExposures
    };
};

export default useDeleteCustomExposure;